import { Reveal } from "./Reveal";

const gold = "#8C7040";
const ink = "#5C4A32";

const DAYS = [
  {
    label: "Day One",
    title: "Arrive & Align",
    icon: "/assets/day-one.png",
    body: ["Settle in. Release", "what no longer serves.", "Create space for", "what matters."],
  },
  {
    label: "Day Two",
    title: "Reflect & Release",
    icon: "/assets/day-two.png",
    body: ["Gentle inquiry.", "Let go of noise.", "Clarify what is", "truly essential."],
  },
  {
    label: "Day Three",
    title: "Focus & Design",
    icon: "/assets/day-three.png",
    body: ["Define your intention.", "Shape your direction.", "Design the next", "aligned step."],
  },
  {
    label: "Day Four",
    title: "Deepen & Embody",
    icon: "/assets/day-four.png",
    body: ["Move into practice.", "Align mind, body", "and actions.", "Make it real."],
  },
  {
    label: "Day Five",
    title: "Integrate & Emerge",
    icon: "/assets/day-five.png",
    body: ["Weave insights", "into lasting change.", "Step forward", "with clarity."],
  },
];

const Flourish = () => (
  <svg viewBox="0 0 280 18" className="mx-auto h-4 w-56" fill="none" aria-hidden="true">
    <path d="M8 9 H118" stroke={gold} strokeWidth="0.7" />
    <path d="M162 9 H272" stroke={gold} strokeWidth="0.7" />
    <path d="M140 9c0-4 4.2-6.5 8-3.2 1.6-2.6 5-2.4 6.2.4 3.6-2.8 7.6-.2 7.2 3.2" stroke={gold} strokeWidth="0.7" />
    <path d="M140 9c0 4 4.2 6.5 8 3.2 1.6 2.6 5 2.4 6.2-.4 3.6 2.8 7.6.2 7.2-3.2" stroke={gold} strokeWidth="0.7" />
    <circle cx="140" cy="9" r="1.1" fill={gold} />
  </svg>
);

export const CinematicSection = () => (
  <section className="relative overflow-hidden bg-[#F8F1E4] px-6 py-24 md:px-10 md:py-28" data-testid="cinematic-section">
    <div className="relative z-[1] mx-auto max-w-6xl text-center">
      <Reveal>
        <h2
          className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl md:text-6xl"
          style={{ color: gold }}
          data-testid="cinematic-headline"
        >
          Five days. Intentional. No more.
        </h2>
        <div className="mt-6">
          <Flourish />
        </div>
        <p
          className="mt-5 flex items-center justify-center gap-4 text-[10px] font-medium uppercase tracking-[0.28em] sm:text-[11px]"
          style={{ color: gold }}
          data-testid="cinematic-body"
        >
          <span className="hidden h-px w-16 sm:block" style={{ backgroundColor: gold }} aria-hidden="true" />
          A curated journey of clarity, renewal and purpose
          <span className="hidden h-px w-16 sm:block" style={{ backgroundColor: gold }} aria-hidden="true" />
        </p>
      </Reveal>

      <div className="mt-14 grid gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-5 lg:gap-0">
        {DAYS.map((day, i) => (
          <Reveal key={day.label} delay={0.05 + i * 0.05} className="h-full">
            <article
              className={`flex h-full flex-col items-center px-4 text-center ${
                i > 0 ? "lg:border-l lg:border-[#C4A36A]/45" : ""
              }`}
              data-testid={`cinematic-day-${i + 1}`}
            >
              <div className="flex h-40 w-full items-center justify-center sm:h-44">
                <img src={`${day.icon}?v=1`} alt="" className="max-h-full w-auto object-contain" />
              </div>
              <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.28em]" style={{ color: gold }}>
                {day.label}
              </p>
              <h3 className="mt-3 font-serif text-xl tracking-tight md:text-[1.35rem]" style={{ color: ink }}>
                {day.title}
              </h3>
              <p className="mt-3 font-serif text-sm leading-relaxed" style={{ color: "#4A4034" }}>
                {day.body.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <img src="/assets/day-mark.png?v=1" alt="" className="mx-auto mt-14 h-14 w-auto" />
        <p className="mt-5 text-[10px] font-medium uppercase tracking-[0.32em] sm:text-[11px]" style={{ color: gold }}>
          Less is depth. Intention is everything.
        </p>
      </Reveal>
    </div>
  </section>
);
